<template>
  <div class="gdpr-page">
    <header-comp />
    <side-bar type="light" width="fluid" />
    <main>
      <div class="container-fluid">
        <slot />
      </div>
    </main>
    <footer-comp />
  </div>
</template>

<script>
import FooterComp from "../footer";
import HeaderComp from "./header";
import SideBar from "./side-bar";

/**
 * Vertical layout
 */
export default {
  components: { HeaderComp, SideBar, FooterComp },
  data() {
    return {};
  },
  computed: {
    isMenuCollapsed() {
      return this.$store.getters["layout/isMenuCollapsed"];
    },
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    toggleMenu() {
      if (this.isMenuCollapsed) {
        document.body.classList.remove("vertical-collpsed");
      } else {
        document.body.classList.add("vertical-collpsed");
      }
      this.$store.dispatch("layout/toggleMenuCollapse");
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.isMenuCollapsed) {
      document.body.classList.add("vertical-collpsed");
    } else {
      document.body.classList.remove("vertical-collpsed");
    }
  },
};
</script>
